const config = {
    apiKey: "AIzaSyDYnjnjYFi-Cvq2f55hjYTXnqSUhJxZbyM",
    authDomain: "meter-image-capturing.firebaseapp.com",
    databaseURL: "https://meter-image-capturing.firebaseio.com",
    projectId: "meter-image-capturing",
    storageBucket: "meter-image-capturing.appspot.com",
    messagingSenderId: "736105538536"
};

export default config;